import React from "react";
import { PageHero } from "../components/PageHero";
import { AIContent } from "../components/AIContent";
import { LiveTicker } from "../components/LiveTicker";
import { T } from "../context/LanguageContext";

export default function EventsPage() {
  return (
    <div>
      <PageHero topic="stadium floodlights night match" title="Events, Schedules, Scores & Records" subtitle="Live, upcoming and completed events with clear statuses, sources and timezone-safe timestamps. Corrections preserve history." listenTargetId="page-content" />
      <div id="page-content" className="mx-auto max-w-7xl space-y-10 px-4 py-12 sm:px-6">
        <AIContent topic="Why trustworthy sports results matter — statuses, corrections and provenance" context="Editorial explaining event statuses (scheduled, live, provisional, final, corrected), why results need official sources, and how records preserve history." />
        <div className="rounded-2xl border border-slate-200 bg-white p-6">
          <h2 className="mb-5 text-xl font-bold text-slate-900 sm:text-2xl"><T>All Events & Scores</T></h2>
          <LiveTicker />
        </div>
      </div>
    </div>
  );
}
